import React from 'react';
import MainHero from '../../components/Hero';
import products from '../../data/products.json';

const Title = () => (
  <>
    Audit File Sharing in <br className="xl:hidden" />
    <span className="text-white">Google Drive</span>
  </>
);

const Hero = () => {
  return (
    <MainHero
      isProduct
      title={<Title />}
      button1={{
        text: 'Install',
        title: 'Install Google Drive Auditor',
        href: products.GA06.install,
      }}
      button2={{
        text: 'Upgrade',
        title: 'Go premium and unlock all features!',
        href: '#pricing',
      }}
    >
      Run a file audit in Google Drive and review who has access to your files
      and folders.
    </MainHero>
  );
};

export default Hero;
